﻿import $ from "jquery";
import tinymce from 'tinymce';
import { showMessage, initTinymce } from "./main";

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forumDetail") return;

    init();
});

function init() {
    initTinymce('Answer', 300);
}


